import { observer } from 'mobx-react';
import { forwardRef, useImperativeHandle } from 'react';
import { EventsLegend } from '../../../../../components/Module/Legend/EventsLegend';
import { useEventsContext } from './context';

interface MapWidgetEventsLegendItemRef {
  remove(): void;
}

export const MapWidgetEventsLegendItem =
  forwardRef<MapWidgetEventsLegendItemRef>((_, ref) => {
    const { layerLoader } = useEventsContext();

    useImperativeHandle(ref, () => ({
      remove: () => {
        if (layerLoader.isVisible) {
          layerLoader.hide();
        }
      },
    }));

    return <BaseLegendItem />;
  });

const BaseLegendItem = observer(() => {
  const { layerLoader } = useEventsContext();

  if (!layerLoader.isVisible) return null;

  return (
    <EventsLegend
      total={layerLoader.count || 0}
      isLoading={layerLoader.isLoading}
      error={layerLoader.error}
    />
  );
});
